# password/NewCtrl
PasswordNewCtrl = ($scope, $filter, $location, $routeParams, flash, PasswordService) ->
  $scope.account = email: $routeParams.email

  $scope.isSubmitting = false

  $scope.submit = ->
    $scope.success = $scope.error = false
    $scope.isSubmitting = true
    PasswordService.create(email: $scope.account.email)
    .then (resp) ->
      flash.success $filter('translate')('_PASSWORD.NEW.SUCCESS')
    .catch (resp) ->
      flash.error $filter('translate')('_PASSWORD.NEW.ERROR')
    .finally ->
      $scope.isSubmitting = false

PasswordNewCtrl.$inject = [
  '$scope'
  '$filter'
  '$location'
  '$routeParams'
  'flash'
  'PasswordService'
]

module.exports = PasswordNewCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/password/new-controller.coffee